<template lang="pug">
.changes-in-past-rent
  h1 {{ $t("property_page.changes_in_past_rent") }}
  .loader.text-center(v-if='loading')
    i.fas.fa-spinner.fa-spin.fa-2x
  .rent-fee-graph(ref='chartdiv')
</template>

<script>
import { api } from '@/api'
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"

export default {
  props: {
    property: {
      type: Object,
      default() {
        return {}
      }
    },
    checkedRooms: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      chart: {},
      loading: true
    }
  },

  watch: {
    checkedRooms() {
      this.chart.series.values.forEach(series => {
        if (this.checkedRooms.includes(series.name)) {
          series.show()
        } else {
          series.hide()
        }
      })
    }
  },

  mounted() {
    this.initChart()
    this.initDateAxis()
    this.initValueAxis()
    this.initSeries()
    this.loading = false
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
  },

  methods: {
    initChart() {
      this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)
      this.chart.svgContainer.htmlElement.style.height = "350px"
      this.chart.paddingTop = 60
      this.chart.paddingBottom = 30
      this.chart.paddingRight = 90
      this.chart.paddingLeft = -30
    },

    initDateAxis() {
      let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.renderer.grid.template.strokeWidth = 0
      dateAxis.renderer.minGridDistance = 30
      dateAxis.baseInterval = { "timeUnit": "year", "count": 1 }
      dateAxis.title.text = this.$t('property_page.year')
      dateAxis.title.fontWeight = "bold"
      dateAxis.title.align = "right"
      dateAxis.title.dy = -20
      dateAxis.title.dx = 40
      dateAxis.fontSize = 13
      dateAxis.renderer.labels.template.fill = am4core.color("#7C91A7")
      dateAxis.title.fill = am4core.color("#3D4A57")
      dateAxis.renderer.labels.template.dy = 10
    },

    initValueAxis() {
      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
      valueAxis.title.text = this.$t('property_page.changes_past_currency')
      valueAxis.renderer.minGridDistance = 30
      valueAxis.title.rotation = 0
      valueAxis.title.fontWeight = "bold"
      valueAxis.title.valign = "top"
      valueAxis.title.dy = -45
      valueAxis.title.dx = 33
      valueAxis.fontSize = 13
      valueAxis.renderer.labels.template.fill = am4core.color("#7C91A7")
      valueAxis.title.fill = am4core.color("#3D4A57")
      valueAxis.renderer.labels.template.dx = -10
      valueAxis.min = 0
    },

    async initSeries() {
      const response = await this.chartData()

      this.property.rooms.forEach(({ id, color, number, floor, layout, area }) => {
        this.createSeries(id, response.data.data[id], color, number, floor, layout, area)
      })
    },

    chartData() {
      return api.get(`properties/${this.property.id}/rent_fees`)
    },

    createSeries(id, data, color, number, floor, layout, area) {
      let series = this.chart.series.push(new am4charts.LineSeries())
      series.data = data
      series.dataFields.valueY = 'value'
      series.dataFields.dateX = 'date'
      series.name = id
      series.strokeWidth = 3
      series.stroke = am4core.color(color)
      series.hidden = !this.checkedRooms.includes(id)

      let bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.strokeWidth = 0
      bullet.circle.radius = 3
      bullet.fill = am4core.color(color)
      let text = `${floor}階\n${layout}\n${area}(㎡)`
      if (number) {
        text = `${number}\n` + text
      }
      bullet.tooltipText = text

      return series
    }
  }
}

</script>

<style lang="scss" scoped>
.changes-in-past-rent {
  h1 {
    color: #3d4a57;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0;
    margin: 4% 0 2% 0;
  }

  .rent-fee-graph {
    background: #fff;
    border: 1px solid #dfe6ee;
    border-radius: 2px;
    height: 442px !important;
    overflow: hidden;
    padding: 20px;
    width: 100%;
  }
}
</style>
